(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ConsultantTypeService', ConsultantTypeService)

    /** @ngInject */
    function ConsultantTypeService(HttpService) {
        const ConsultantTypeService = {
            getAll,
            getByParameters,
            post,
            put,
            migrateData,
            deleteData
        }

        return ConsultantTypeService;

        function getAll() {
            return HttpService.get('/consultant-types/by-parameters', {
                params: {}
            });
        }

        function getByParameters(params) {
            return HttpService.get('/consultant-types/by-parameters', {
                params
            });
        }

        function post(consultantTypeData) {
            return HttpService.post('/consultant-types', consultantTypeData);
        }

        function put(consultantTypeData) {
            return HttpService.put('/consultant-types', consultantTypeData);
        }

        function migrateData(consultantTypeOriginId, consultantTypeDestinationId) {
            return HttpService.put(`/consultant-types/migrate/${consultantTypeOriginId}/${consultantTypeDestinationId}`);
        }

        function deleteData(consultantTypeId) {
            return HttpService.delete(`/consultant-types/${consultantTypeId}`);
        }
    }
}());